import React from "react";

const WBGarageSaleNotActive = () => {
  return (
    <div style={{
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        background: "#EEEEEE"
    }}>
      <div className="ui container" style={{ paddingTop: "2em" }}>
        <div className="ui segment">
          <h4 className="ui header">
            This app is not available, please check back at another time.
          </h4>
          <div className="ui divider"></div>
          <div className="ui bulleted list">
            <div className="item">
              <a href="http://www.westburlington.org/">
                West Burlington Homepage
              </a>
            </div>
            <div className="item">
              <a href="https://www.dmcwebgis.com/apps/">
                Des Moines County GIS applications
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WBGarageSaleNotActive;
